// extracted by mini-css-extract-plugin
export var image = "c3_dr";